import { makeStyles } from '@material-ui/core/styles';
import { condensedStyles } from 'core/components/theme/condensed-layout';

const styles = (theme) => ({
  cardContainer: {
    width: 720,
    ...condensedStyles(theme, { width: '100%', maxWidth: 720 }),
    margin: theme.spacing(0, 'auto'),
    padding: theme.spacing(8),
    backgroundColor: theme.colors.panel_background,
    border: `2px solid ${theme.colorPalette.white}`
  },
  content: {
    fontSize: 14,
    lineHeight: 1.43
  },
  link: {
    color: theme.palette.secondary.main
  },
  checklistContainer: {
    maxWidth: 'none',
    gap: theme.spacing(3)
  }
});

export default makeStyles(styles);
